export const isEmpty = (string?: string): boolean => {
    if (!string) return true;
    return string.trim() === '';
}

